const grillaSolicitudesState = {
  modalVerDetalle: false,
  idSolicitudDetalle: 0,
  loadingFile: false,
};

export default grillaSolicitudesState;
